module.exports = __webpack_public_path__ + "img/vertical_4_5_7016.0d016f53.png";